var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8741 2.47076C14.8664 2.34851 14.8114 2.23316 14.7194 2.14656C14.6274 2.05997 14.5048 2.00817 14.3749 2.00097C9.30725 1.72018 5.24966 3.15829 3.51937 5.84719C2.91944 6.76907 2.62393 7.83788 2.67032 8.91805C2.70808 9.91535 3.01717 10.9221 3.58832 11.9158L10.2494 5.64657C10.349 5.5529 10.4841 5.50031 10.6249 5.50035C10.7658 5.50039 10.9008 5.55306 11.0004 5.64679C11.1 5.74052 11.156 5.86763 11.156 6.00018C11.156 6.13273 11.1002 6.25987 11.0006 6.35366L4.33962 12.6229C5.39541 13.1604 6.46505 13.4513 7.52469 13.4869C7.59888 13.4894 7.67258 13.4906 7.74618 13.4906C8.81941 13.4935 9.87237 13.2155 10.7875 12.6878C13.6444 11.0593 15.1721 7.23977 14.8741 2.47076Z",
    fill: "#2DA771"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79447 12.2571C3.72201 12.1435 3.65388 12.0296 3.58833 11.9155L2.28062 13.1463C2.18098 13.2401 2.12501 13.3673 2.125 13.4999C2.12499 13.6325 2.18096 13.7597 2.28059 13.8534C2.38021 13.9472 2.51534 13.9999 2.65624 13.9999C2.79714 13.9999 2.93227 13.9472 3.03191 13.8535L4.33963 12.6227C4.21848 12.561 4.09745 12.4968 3.9767 12.4287C3.90192 12.3864 3.83933 12.3275 3.79447 12.2571V12.2571Z",
    fill: "#2DA771"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.c8adc891dac731902f0eb4af4f26026c.svg";
export { ForwardRef as ReactComponent };